import { Workflow } from "../Models/Workflow";
import { LoadingState } from "../../Common";
import {
  WorkflowAction,
  WorkflowActionType,
  IWorkflowLoadedPayload,
  ISetWorkflowErroredPayload
} from "../Actions/WorkflowActions";

export interface WorkflowState {
  workflow?: Workflow;
  loadingState: LoadingState;
  errorMessage: string;
  errorCode?: number;
}

const initialWorkflowState: WorkflowState = {
  loadingState: {
    isLoaded: false,
    isLoading: false,
    errored: false
  },
  errorMessage: ""
};

const updateObject = (oldObject: any, newValues: any) => ({ ...oldObject, ...newValues });

const workflowReducer = (
  workflowState: WorkflowState = initialWorkflowState,
  action: WorkflowAction
) => {
  switch (action.type) {
    case WorkflowActionType.WORKFLOW_LOADED: {
      const payload = <IWorkflowLoadedPayload>action.payload;

      const { loadedWorkflow } = payload;

      return updateObject(workflowState, {
        workflow: loadedWorkflow,
        loadingState: {
          isLoaded: true,
          isLoading: false,
          errored: false
        }
      });
    }
    case WorkflowActionType.WORKFLOW_UNLOAD: {
      return updateObject(workflowState, {
        workflow: undefined,
        loadingState: {
          isLoaded: false,
          isLoading: false,
          errored: false
        }
      });
    }
    case WorkflowActionType.WORKFLOW_SET_LOADING: {
      return updateObject(workflowState, {
        workflow: undefined,
        loadingState: {
          isLoaded: false,
          isLoading: true,
          errored: false
        }
      });
    }
    case WorkflowActionType.WORKFLOW_SET_ERRORED: {
      const payload = <ISetWorkflowErroredPayload>action.payload;
      return updateObject(workflowState, {
        workflow: undefined,
        loadingState: {
          isLoaded: false,
          isLoading: false,
          errored: true
        },
        errorMessage: payload.errorMessage,
        errorCode: payload.errorCode
      });
    }
    default:
      return workflowState;
  }
};

export default workflowReducer;
